import { defineComponent as _defineComponent } from 'vue'
import {computed, onBeforeMount, onMounted, ref, watch} from 'vue';
import {getPermissionData} from '@/api/miscellaneous';
import appStoreModule from '@/store/modules/app';
import {useRoute, useRouter} from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose }) {
  expose();

const route = useRoute();
const router = useRouter();
const tabbar = ref();
const active = ref('');
const tabbarHeight = ref(0);
const isShowTab = ref(!route.meta.isHideTab);
const isShowKefu = ref(!route.meta.isShowKefu);
const tabbarIcons = ref({
    home: {
        inactive: require('@/assets/img/tab/tab_new_home.png'),
        active: require('@/assets/img/tab/tab_new_home_act.png'),
    },
    release: {
        inactive: require('@/assets/img/tab/home_publish_tab_new.png'),
        active: require('@/assets/img/tab/home_publish_tab_new.png'),
    },
    businessOpportunity: {
        inactive: require('@/assets/img/tab/tab_new_shangji.png'),
        active: require('@/assets/img/tab/tab_new_shangji_act.png'),
    },
    supply: {
        inactive: require('@/assets/img/tab/tab_new_supply.png'),
        active: require('@/assets/img/tab/tab_new_supply_act.png'),
    },
    purchase: {
        inactive: require('@/assets/img/tab/tab_new_purchase.png'),
        active: require('@/assets/img/tab/tab_new_purchase_act.png'),
    },
    profile: {
        inactive: require('@/assets/img/tab/tab_new_user.png'),
        active: require('@/assets/img/tab/tab_new_user_act.png'),
    },
});

const isShowRelease = ref(false);

onBeforeMount(() => {
    getPermissionData().then(res => {
        appStoreModule.setPermission(res);
    });
});

onMounted(() => {
    setTimeout(() => {
        tabbarHeight.value = tabbar.value.$el.offsetHeight;
    }, 0);
});

const tabChange = (name: string) => {
    name && name != 'Release' && router.push(name);
};

const height = computed(() => {
    return ` ${isShowTab.value ? tabbarHeight.value : 0}px`;
});

watch(route, () => {
    isShowTab.value = !route.meta.isHideTab;
    active.value = route.name as string;
    isShowKefu.value = !!route.meta.isShowKefu;
});

const toKefu = () => {
    // getWechatAppUrl({
    //     url: 'packageA/pages/connectService/index',
    // }).then(res => {
    //     window.location.href = JSON.parse(res).openlink;
    // });
    window.location.href = 'https://work.weixin.qq.com/kfid/kfcdd1c5b9f6d099505';
};

const __returned__ = { route, router, tabbar, active, tabbarHeight, isShowTab, isShowKefu, tabbarIcons, isShowRelease, tabChange, height, toKefu, computed, onBeforeMount, onMounted, ref, watch, getPermissionData, appStoreModule, useRoute, useRouter }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})